import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../Components/Layout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import EyeOpenIco from "../Components/Images/eye.svg";
import EyeCloseIco from "../Components/Images/eye-slash.svg";
import { set, useForm } from 'react-hook-form';
import { PostApiWithoutLogin } from '../apiService';
import { API_PATH } from '../const';
import { toast } from 'react-toastify';
import Loader from '../Components/Layout/Loader';

function LoginAdmin(props) {

    const navigate = useNavigate();
    
    const location = useLocation();
    
    const [showPassword, setshowPassword] = useState("password");
    const [rm, set_rm] = useState(false);
    const [verify_user, set_verify_user] = useState(false);
    const [name, set_name] = useState("");
    const [email, set_email] = useState("");
    const [loader, set_loader] = useState(false);

    const { 
            register, 
            handleSubmit, 
            getValues,
            reset,
            formState: { errors }, 
        } = useForm(); 
    
        const onSubmit = useCallback(() => {
            set_loader(true);
            const data = getValues();
            set_email(data.email);
            const RunQuery = Promise.resolve(PostApiWithoutLogin(API_PATH.AdminLogin, data));
            RunQuery.then(response => {
                if(response.status === 200){
                    const jwt_token = "Bearer " + response.data?.data?.token
                    localStorage.setItem('PPKTOKEN', jwt_token);
                    navigate('/dashboard', { state: { jwt_token } });
                    reset();
                } else if(response.status === 401) {
                    set_verify_user(true);
                } else toast.error(response.response.data.message);
                set_loader(false);
            })
        }, [getValues]);

    return (
        <Layout>
            {loader === true ? <Loader></Loader> : <></>}
            <section className='common-space-both container pt-4'>
                <div className='common-title'>
                    <h1 className='text-black'>Access Your <span>Dashboard</span></h1>
                </div>
                <div className="sign-form-cust mt-4">
                    <h1 className="text-center">Admin Login</h1>
                    <p className="text-center"></p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-2 pb-1">
                            <label className="lbl-info-common">Email Address</label>
                            <input 
                                type="email" 
                                className="form-control form-style-input" 
                                placeholder=""
                                {...register("email", { required: "Please Enter Your Email" })}
                            />
                        </div>
                        <div className="mb-2 pb-1">
                            <label className="lbl-info-common">Password</label>
                            <div className="position-relative login-icons-div">
                                <input 
                                    type={showPassword} 
                                    className="form-control form-style-input" 
                                    placeholder="" name="password" 
                                    {...register("password", { required: "Please Enter Your Password" })}
                                />
                                <div className="eyes-icons-div">
                                    <img
                                        src={showPassword === "password" ? EyeCloseIco : EyeOpenIco}
                                        loading="lazy"
                                        alt="Password"
                                        className="img-fluid"
                                        onClick={() => setshowPassword(showPassword === "password" ? "text" : "password")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mb-2 pb-1">
                            <div className="row me-0">
                                <div className="col-6 pe-0">
                                    <label className="cust-chk-bx">
                                        <input 
                                            type="checkbox" 
                                            className="form-check-inpu" 
                                            name=""
                                            {...register("rm")}
                                        />
                                        <span className="cust-chkmark"></span>
                                        Remember me
                                    </label>
                                </div>
                                <div className="col-6 pe-0">
                                    <div className="text-end">
                                        <Link className="frt-lnk-last primary-color" to="/forgot-password">
                                            Forgot Password ?
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pt-2">
                            <button className="btn-all-comn w-100" type="submit">
                                Login
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </Layout>
    );
}

export default LoginAdmin;